/* OchreLane — "next image" arrow on the phone product gallery. Added 3 Nov 2026.
   The button sits in sections/main-product.liquid (inside <product-gallery>) and is
   styled in ol-pdp-updates.css §8. Each tap moves the swipe gallery one image along;
   the arrow hides on the last image. Images the theme hides for other variants are
   skipped. Works with or without the thumbnail strip. */
(function () {
  'use strict';
  if (window.OLGalleryNext) return;
  window.OLGalleryNext = true;

  function slides(list) {
    return Array.prototype.filter.call(list.children, function (li) { return li.offsetWidth > 0; });
  }

  function update(gallery) {
    var list = gallery && gallery.querySelector('.product__media-list');
    var button = gallery && gallery.querySelector('[data-ol-gallery-next]');
    if (!list || !button) return;
    var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    button.hidden = atEnd || slides(list).length < 2;
  }

  function updateAll() {
    Array.prototype.forEach.call(document.querySelectorAll('product-gallery'), update);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-ol-gallery-next]');
    if (!button) return;
    var list = button.closest('product-gallery').querySelector('.product__media-list');
    var items = slides(list);
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetLeft > list.scrollLeft + 4) {
        list.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
        return;
      }
    }
  });

  // "scroll" doesn't bubble, so listen while it travels down.
  document.addEventListener('scroll', function (event) {
    var list = event.target;
    if (list.classList && list.classList.contains('product__media-list')) update(list.closest('product-gallery'));
  }, true);

  document.addEventListener('variant:change', function () { setTimeout(updateAll, 600); });
  window.addEventListener('resize', updateAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else updateAll();
})();
